module.exports = __webpack_public_path__ + "static/media/boxeo.cd2b0a07.jpg";